import { render, staticRenderFns } from "./TestingMenu.vue?vue&type=template&id=37c0c248"
import script from "./TestingMenu.vue?vue&type=script&lang=js"
export * from "./TestingMenu.vue?vue&type=script&lang=js"
import style0 from "./TestingMenu.vue?vue&type=style&index=0&id=37c0c248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports